// Trims all string values in an object (shallow)
export const trimData = (data) => {
    if (typeof data !== 'object' || data === null) return data;
    const trimmed = {};
    for (const key in data) {
        if (typeof data[key] === 'string') {
            trimmed[key] = data[key].trim();
        } else {
            trimmed[key] = data[key];
        }
    }
    return trimmed;
};
